<script>
	import Barra from './componentes/barra.svelte';
	import Router from 'svelte-spa-router';
	import NuevaCuenta from './vistas/forms/nuevaCuenta.svelte';
	import Home from './vistas/home.svelte';
	import Login from './vistas/login.svelte';
import Cuenta from './vistas/cuenta.svelte';
import NuevaFirma from './vistas/forms/nuevaFirma.svelte';
import EditarDatos from './vistas/forms/editarDatos.svelte';
import NuevaReceta from './vistas/forms/nuevaReceta.svelte';
import Historial from './vistas/historial.svelte';
import NuevaPlantilla from './vistas/forms/nuevaPlantilla.svelte';
import ShowReceta from './vistas/showReceta.svelte';
	let routes = {
		'/': Login,
		'/home':Home,
		'/primera/vez': NuevaCuenta,
		'/cuenta':Cuenta,
		'/cambiar/firma':NuevaFirma,
		'/editar/cuenta':EditarDatos,
		'/nueva/receta':NuevaReceta,
		'/historial':Historial,
		'/nueva/plantilla':NuevaPlantilla,
		'/ver/receta/:id':ShowReceta
	}
</script>
<Barra />
<Router {routes} />

<style>
	:global(:root){
		--azul: #3e85ff;
		--negro: #2B303A;
	}
	:global(body){
		font-family: 'Work Sans', sans-serif;
	}
	:global(.input){
		border-radius: 10px;
		border: none;
		outline: none;
		height: 30px;
		padding: 5px;
	}
	:global(.container){
		overflow: hidden;
		width: 100vw;
		max-width: 100%;
		height: calc(100vh - 50px);
		max-height: 100%;
		background: var(--azul);
	}
</style>

